import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function getTaskGroupsSectionsReducer(state = initialState.taskGroupsSections, action) {
	switch (action.type) {
		case types.GET_TASK_GROUPS_SECTIONS: {
			let taskGroupsSections = action.response;
			return [...taskGroupsSections];
		}

		case types.CREATE_TASK_GROUPS: {
			if (action.responseObj.status === HttpStatusCodes.Created) {
				// add response object into state
				let newState = _.cloneDeep(state);

				// set isNew as false
				newState.forEach((item) => {
					item.isNew = false;
				});

				// set new item as new
				let newItem = {
					taskGroupSectionId: action.response.taskSectionId,
					isSelectedTaskGroupSection: false,
					taskSectionId: action.response.taskSectionId,
					isCustom: true,
					includeMilestones: true,
					taskGroupSectionName: action.response.taskSectionName,
					taskGroupId: null,
					auditPhaseId: action.response.auditPhaseId,
					isKnowledgeSection: false,
					uiDisplayOrder: 0,
					relatedTasks: null,
					isNew: true
				};

				newState.push(newItem);
				return [...newState];
			} else {
				return state;
			}
		}
		case types.CLEAR_TASK_GROUPS_SECTIONS: {
			return {};
		}
		default:
			return state;
	}
}
